import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Pages } from '../../../../types/offers';
import { stepNames } from '../../lib/side-effects/progress-bar';
import { setCurrentOfferPage } from '../../store/offer';
import BuyButton from './buy-button';
import OrderSummary from './order-summary';

const StandaloneSummary = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentOfferPage(Pages.Summary));
    dispatch(setProgressBarCurrentStep(stepNames.reviewAndBuy));
  }, []);

  return (
    <Fragment>
      <OrderSummary />
      <BuyButton />
    </Fragment>
  );
};

export default StandaloneSummary;
